import RegularText from '@/components/RegularText';
import SkeletonPage from '@/components/SkeletonPage';
import { Divider, Modal, ModalProps } from '@shopify/polaris';

interface IProps extends ModalProps {
  description?: string | React.ReactNode;
  hideChildren?: boolean;
}

export default function BaseModal({ children, description, hideChildren, ...props }: IProps) {
  return (
    <Modal {...props}>
      {props?.loading ? (
        <SkeletonPage />
      ) : (
        <>
          {description ? (
            <>
              <div style={{ padding: '10px 16px' }}>
                <RegularText>{description}</RegularText>
              </div>
              <Divider />
            </>
          ) : null}
          {hideChildren ? null : <Modal.Section>{children}</Modal.Section>}
        </>
      )}
    </Modal>
  );
}
